(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-header-section-hulkapps-backup"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-header-section"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section"] && !Shopify.designMode) return;
  try {
    

  
  document.addEventListener('DOMContentLoaded', function () {
    console.log('DOM fully loaded. Waiting for Kaching Bundle...');

    function waitForKaching(callback, maxWait = 10000) {
      const interval = 100;
      let waited = 0;

      const check = () => {
        if (window.KachingBundle || window.kaching) {
          console.log('Kaching Bundle loaded:', window.KachingBundle || window.kaching);
          callback(window.KachingBundle || window.kaching);
        } else if (waited >= maxWait) {
          console.warn('Kaching Bundle not found after waiting.');
        } else {
          waited += interval;
          setTimeout(check, interval);
        }
      };

      check();
    }

    waitForKaching((kaching) => {
      // Your logic after Kaching is ready goes here
      console.log('You can now use Kaching:', kaching);

      // Example:
      // kaching.doSomething()
    });
  });


   
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-block"] && !Shopify.designMode) return;
  try {
    
                    var selected_shade = '' ;
                  
  
  document.addEventListener('DOMContentLoaded', function() {
   var $slider = $('.js-shade-groups');
      
    $slider.on('init', function(event, slick) {
            var currentSlideElement = $(slick.$slides[slick.currentSlide]);
            var myAttribute = currentSlideElement.attr('data-shade');
           selected_shade = myAttribute ;
          
          });
      const slideCount = $('.js-shade-groups .shade-group-section').length;
            $slider.slick({
            slidesToShow: 1,               // scrolls 1 at a time
            slidesToScroll: 1,
        
            variableWidth: true, 
            centerMode : true ,
            autoplay: false,
            infinite : true ,
             arrows : false ,
              dots : false ,
            autoplaySpeed: 2000
          });

              // Handle update on slider change
           $slider.on('afterChange', function (event, slick, currentSlide) {
              const percentage = (currentSlide / (slideCount - 1)) * 100;
              $('.shade-handle').css('left', `${percentage}%`);
               var currentSlideElement = $(slick.$slides[slick.currentSlide]);
              var myAttribute = currentSlideElement.attr('data-shade');
               selected_shade = myAttribute ;
             
             
            });
           
          
            // Label click -> go to slide
            $('.shade-labels span').each(function (index) {
              $(this).on('click', function () {
                $('.js-shade-groups').slick('slickGoTo', index);
              });
            });
          
            // Dragging handle
          $('.shade-handle').on('mousedown touchstart', function (e) {
            e.preventDefault();
          
            const bar = $('.shade-bar');
            const handle = $(this);
            const barOffset = bar.offset();
            const barWidth = bar.width();
          
            // Handle both mouse and touch move events
            function onMove(e) {
              let clientX = e.type === 'touchmove' ? e.originalEvent.touches[0].pageX : e.pageX;
              let mouseX = clientX - barOffset.left;
              mouseX = Math.max(0, Math.min(mouseX, barWidth));
          
              const percentage = mouseX / barWidth;
              handle.css('left', `${percentage * 100}%`);
            }
          
            // Handle both mouseup and touchend
            function onEnd(e) {
              let clientX;
              if (e.type === 'touchend') {
                const touch = e.originalEvent.changedTouches[0];
                clientX = touch.pageX;
              } else {
                clientX = e.pageX;
              }
          
              let mouseX = clientX - barOffset.left;
              mouseX = Math.max(0, Math.min(mouseX, barWidth));
          
              const percentage = mouseX / barWidth;
              const nearestSlide = Math.round(percentage * (slideCount - 1));
          
              $('.js-shade-groups').slick('slickGoTo', nearestSlide);
          
              $(document).off('.shadedrag');
            }
          
            $(document).on('mousemove.shadedrag touchmove.shadedrag', onMove);
            $(document).on('mouseup.shadedrag touchend.shadedrag touchcancel.shadedrag', onEnd);
          });
            let currentStep = 0;
            const $steps = $('.quiz-content');
           
  
            function showStep(index) {
              $steps.removeClass('active').hide();
              $steps.eq(index).addClass('active').show();
            }
            function hasSelection(stepIndex) {
              if (stepIndex === 0) return true;
            // Find selected option inside current step
            return $steps.eq(stepIndex).find('.quiz-option.selected').length > 0;
          }
        function getProductLinkById(productId) {
            var handle = window.productIdMap[productId];
            if (handle) {
              return '/products/' + handle;
            } else {
              console.warn('Product ID not found:', productId);
              return null;
            }
          }
         function getTopMatchingRecommendations(answers, data) {
              const answerValues = Object.values(answers);
            
              const ranked = data.map(rec => {
                const matchCount = rec.conditions.filter(condition => answerValues.includes(condition)).length;
                return {
                  ...rec,
                  matchCount
                };
              });
             
              const maxMatches = Math.max(...ranked.map(r => r.matchCount));
            
              return ranked.filter(r => r.matchCount === maxMatches && maxMatches > 0);
            }
   
          // When a quiz-option is clicked, mark it as selected
          $(document).on('click', '.quiz-option', function () {
            const $thisStep = $(this).closest('.quiz-content');
          
            // Remove selected class from all options in this step
            $thisStep.find('.quiz-option').removeClass('selected');
          
            // Mark clicked one as selected
            $(this).addClass('selected');
          });
          
          // NEXT BUTTON
          $('.quiz-next-button').on('click', function () {
            if (!hasSelection(currentStep)) {
              alert("Please select an option to continue.");
              return;
            }
            // If this is the last step, collect all answers
            if (currentStep === $steps.length - 1) {
              const answers = [];
               
              $steps.each(function(index) {
                const selected = $(this).find('.quiz-option.selected');
                if (selected.length > 0) {
                  const value = selected.data('value');
                  answers.push(value);
                  
                }
              });
                answers.push(selected_shade);
          
              
              const recommendationData = JSON.parse(document.getElementById("recommendation-data").textContent);
              const bestMatches = getTopMatchingRecommendations(answers, recommendationData);
            

              if (bestMatches.length > 0) {
                // Show the best match (you could show all with same score)
                const top = bestMatches[0]; 
             
                
                var link = getProductLinkById(top.product_id);
                  if (link) {
                    console.log('Product link:', link);
                    fetch(link+'.js')
                        .then(res => res.json())
                        .then(product => {
                              const matchedVariant = product.variants.find(variant => {
                                  const formattedTitle = variant.title.toLowerCase().replace(/\s+/g, '-');
                                  return formattedTitle === selected_shade;
                                });
                            
                        if (matchedVariant) {
                           const productLink = `/products/${product.handle}?variant=${matchedVariant.id}`;
                               $('#resultShade').text(matchedVariant.title);
                              $('#resultImage').attr('src',top.image);
                              $('#resultLink').attr('href',productLink);
                              $('#featureList').html(top.text);
                              const variantImage = matchedVariant.featured_image
                              ? matchedVariant.featured_image.src
                              : product.images[0] || null;

                            if( variantImage !== null ) {
                              $('#resultImage').attr('src',variantImage);
                            }
                          console.log(variantImage);
                          $('.quiz-results').show()
                          $('.quiz-section').hide();
                          } 
                      });
                   
                  }
                
              } else {
                  // No match
                 alert('Try updating your choices');
              }
              
              // Optional: Do something with `answers` here
              // e.g., send to server, show result screen, etc.
          
              return; // prevent moving to non-existent next step
            }
          
            if (currentStep < $steps.length - 1) {
              currentStep++;
              showStep(currentStep);
            }
            
          });
        
          $('.quiz-back-button').on('click', function() {
            if (currentStep > 0) {
              currentStep--;
              showStep(currentStep);
            }
            
            
            if( currentStep == 1 ) {
              $('.quiz-section').hide();
              $('.quiz-intro').show() ;
            }
          });

        showStep(currentStep); 
      $('#startQuiz').on('click', function() {
        $('.quiz-intro').hide() ;
        $('.quiz-section').show() ;
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick'); // Destroy the current instance
          }

         $slider.slick({
            slidesToShow: 1,               // scrolls 1 at a time
            slidesToScroll: 1,
        
            variableWidth: true, 
            centerMode : true ,
            autoplay: false,
            infinite : true ,
             arrows : false ,
              dots : false ,
            autoplaySpeed: 2000
          });
      })
    
          
  });

   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    $('.js-resuls-gallery').slick({
      slidesToShow: 1,               // scrolls 1 at a time
      slidesToScroll: 1, 
     centerMode : true , 
      infinite : true ,
      variableWidth: true  ,
       arrows : false ,
      dots : false ,
      autoplaySpeed: 2000
    });

    $(document).on('click', '.shopping-button', function() {
        const $btn = $(this);
        const productName = $btn.data('product-name');
        const shade = $btn.data('shade');
        const target = $(document).find('#product-buy');
       $(target).find('.product-images-buybox__shade-option[data-title="'+shade+'"]').trigger('click');
       
        
        $('html, body').animate({
            scrollTop: $(target).offset().top
          }, 600); 
            
        });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    if (window.jQuery && typeof jQuery.fn.slick === 'function') {
      $('.testimonial-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 3000,
        slidesToShow: 3,
        slidesToScroll: 3,
          autoplay: true,
        aotoplaySpeed : 3000,
          responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
       
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
      
      
      });
    } else {
      console.error('Slick Slider not loaded. Please include slick.min.js');
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-inside"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    if (window.jQuery && typeof jQuery.fn.slick === 'function') {
      $('.js-ingredients').slick({
     slidesToShow: 1,               // scrolls 1 at a time
      slidesToScroll: 1, 
      autoplay: true,
      infinite : false ,
        variableWidth : true ,
       arrows : false ,
        dots : false ,
      autoplaySpeed: 2000 ,
         responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                 variableWidth : false ,
              }
            }


           ]
    
           
      });
    } else {
      console.error('Slick Slider not loaded. Please include slick.min.js');
    }
  });


  } catch(e) { console.error(e); }
})();
})();
